// @flow
import React from 'react'
import PasswordResetForm from './form'
import { useOutletContext } from 'react-router-dom'

const PasswordReset = (): any => {
  const { auth } = useOutletContext()

  return (
    <div className='pw-reset-email'>
      <div className='pw-reset-email__header'>
        <i className='icon icon--logo' />
        <h3>Forgot Your Password?</h3>
        <h4>Submit your email address to start the recovery process.</h4>
      </div>
      <PasswordResetForm auth={auth} />
    </div>
  )
}

PasswordReset.displayName = 'PasswordReset'

export default PasswordReset
